// extracted by mini-css-extract-plugin
export default {"button":"PromotionHeadBand_button__guiI+"};